import React, { useState, createContext, useContext } from 'react';
export type PlanId = 'esencial' | 'pro';
export interface Plan {
  id: PlanId;
  name: string;
  longName: string;
  priceBefore: string;
  price: string;
  desc: string;
  url: string;
  featured?: boolean;
  benefits: string[];
}
export const PLANS: Record<PlanId, Plan> = {
  esencial: {
    id: 'esencial',
    name: 'Sistema Esencial',
    longName: 'Sistema Docente Italiano',
    priceBefore: '$34.990',
    price: '$19.990',
    desc: '6 módulos + 6 bonos estratégicos',
    url: 'https://checkout.infodigitalcore.shop/cart/49563007615215:1',
    benefits: ['6 módulos completos — 50/60 págs. c/u', '6 bonos de alto valor — 40 págs. c/u', 'Kit de 36 herramientas listas para usar', '+570 páginas de sistema accionable', 'Acceso inmediato — PDF digital']
  },
  pro: {
    id: 'pro',
    name: 'Pack PRO Completo',
    longName: 'Sistema Docente Italiano PRO',
    priceBefore: '$43.990',
    price: '$29.990',
    desc: '6 módulos + 6 bonos + 2 Tomos PRO™',
    url: 'https://checkout.infodigitalcore.shop/cart/49595757297903:1',
    featured: true,
    benefits: ['Todo lo de la oferta esencial', 'Tomo PRO I: Italiano Corporativo', 'Tomo PRO II: De Profesor a Negocio Digital', 'Hoja de ruta de 90 días para escalar ingresos', '+770 páginas de sistema completo']
  }
};
interface PlanContextValue {
  selectedId: PlanId;
  setSelectedId: (id: PlanId) => void;
  selectedPlan: Plan;
}
const PlanContext = createContext<PlanContextValue | undefined>(undefined);
export const PlanProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [selectedId, setSelectedId] = useState<PlanId>('pro');
  return <PlanContext.Provider value={{
    selectedId,
    setSelectedId,
    selectedPlan: PLANS[selectedId]
  }} data-id="element-269">
      {children}
    </PlanContext.Provider>;
};
export const useSelectedPlan = () => {
  const ctx = useContext(PlanContext);
  if (!ctx) throw new Error('useSelectedPlan must be used inside PlanProvider');
  return ctx;
};